/* eslint-disable no-param-reassign */
import produce from "immer";
import {
  MASSUPLOAD_REQUEST,
  MASSUPLOAD_SUCCESS,
  MASSUPLOAD_FAILURE,
  MASSUPLOAD_CLEAR,
  MASSUPLOAD_HISTORY_REQUEST,
  MASSUPLOAD_HISTORY_SUCCESS,
  MASSUPLOAD_HISTORY_FAILURE
} from "src/actions/massuploadActions";

const initialState = {
  history: [],
  total: 0,
  massuploadResponse: null,
  loading: false
};

const massuploadReducer = (state = initialState, action) => {
  switch (action.type) {
    case MASSUPLOAD_REQUEST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case MASSUPLOAD_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.massuploadResponse = response;
        draft.loading = false;
      });
    }

    case MASSUPLOAD_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case MASSUPLOAD_HISTORY_REQUEST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case MASSUPLOAD_HISTORY_SUCCESS: {
      const {response, total} = action.payload;
      return produce(state, (draft) => {
        draft.history = response;
        draft.total = total;
        draft.loading = false;
      });
    }

    case MASSUPLOAD_HISTORY_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case MASSUPLOAD_CLEAR: {
      return produce(state, (draft) => {
        draft.massuploadResponse = null;
      });
    }

    default: {
      return state;
    }
  }
};

export default massuploadReducer;
